import script from "./ModalDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ModalDetail.vue?vue&type=style&index=0&id=70e8f376&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e8f376"]])

export default __exports__